import history from 'config/history';

import { fetchTranslations } from 'store/modules/translations';

import { Market } from './../graphql/generated/graphql';
import { containsLocale } from './locales';

const prependUserMarketToUrl = ({ currentPathname, dispatch, userMarket }) => {
  const { search } = window.location;
  const newPathname = `/${userMarket.toLowerCase()}${currentPathname}${search}`;

  history.replace(newPathname);

  dispatch(fetchTranslations(userMarket));
};

export const buildNewPathName = (currentPathname, urlLocale, userMarket) => {
  if (currentPathname === '/') {
    return `/${userMarket.toLowerCase()}`;
  } else {
    if (containsLocale(currentPathname)) {
      return currentPathname.replace(
        urlLocale.toLowerCase(),
        userMarket.toLowerCase(),
      );
    } else {
      const { search } = window.location;

      return `/${userMarket.toLowerCase()}${currentPathname}${search}`;
    }
  }
};

export const marketToString = (market: Market): string => {
  switch (market) {
    case Market.De:
      return 'de';
    case Market.EnGb:
      return 'en-GB';
    case Market.EnUs:
      return 'en-US';
    case Market.FrFr:
      return 'fr-FR';
  }
};

/**
 * - `currentPathName`: Current url.
 * - `dispatch`:  Redux dispatch function.
 * - `urlLocale`: Locale from the URL. If the URL does not have (femtasy.com or locahost) is the REDUX default.
 * - `userMarket`: User's market if logged in or first visited market if logged out.
 */
const redirectToUserMarketIfNeeded = ({
  currentPathname,
  dispatch,
  urlLocale,
  userMarket,
}) => {
  if (urlLocale) {
    if (urlLocale !== userMarket) {
      const newPathname = buildNewPathName(
        currentPathname,
        urlLocale,
        userMarket,
      );

      window.location.href = newPathname;

      dispatch(fetchTranslations(userMarket));
    } else if (!containsLocale(currentPathname)) {
      const newPathname = buildNewPathName(
        currentPathname,
        urlLocale,
        userMarket,
      );

      window.location.href = newPathname;
    }
  } else {
    prependUserMarketToUrl({ currentPathname, dispatch, userMarket });
  }
};

export default redirectToUserMarketIfNeeded;
